/**
 * tutorActivityActions — le mot et le glyphe de chaque geste du tuteur sur une activité (pur).
 *
 * Ceux du legacy (`ToolbarButton`, `Menu.Item` de `TodoModal`), écrits une fois : la fiche
 * (`<TutorActivityDetailsModal>`, son pied et son ⋮) et le centre du live (`<TutorLiveCenterHead>`, sa
 * tête, et la feuille ⋮ de `<TutorLiveCenter>`) les lisent tous deux.
 */
import { type UITutorActivityAction } from "../../../ports/primary/ui/types/tutorEleves"
import { type IconName } from "../../atoms/icons/Icon/iconRegistry"

/** `short` : le mot d'un geste quand la place manque (le centre étroit) ; il garde un texte. */
export const ACTIVITY_ACTIONS: Record<UITutorActivityAction, { label: string; icon: IconName; short?: string }> = {
    show: { label: "Afficher à l'élève", icon: "eye", short: "Afficher" },
    generate: { label: "Générer...", icon: "magic" },
    submit: { label: "Soumettre", icon: "bolt" },
    validate: { label: "Valider", icon: "check" },
    redo: { label: "Redonner", icon: "redo" },
    editTitle: { label: "Modifier le titre", icon: "pencil-alt" },
    archive: { label: "Archiver", icon: "archive" },
    restore: { label: "Restaurer", icon: "undo-alt" },
}

/**
 * « Afficher à l'élève », quand il l'a déjà devant lui : le bouton passe à sa forme « déjà fait »
 * (`<Button done>`), dont la coche est le glyphe ; le mot ne la répète pas.
 */
export const ACTIVITY_SHOWN_LABEL = "Affichée chez l'élève"
export const ACTIVITY_SHOWN_SHORT = "Affichée"
